import { createSelector } from 'reselect';
import { StoreType } from './index';
import { AsyncActionStatus } from '../actions/common.actionTypes';
import { SearchLoadingStatus } from './search.selectors';
import { MindItem } from '@klab-berlin/api-sdk/lib/types/responses/MindItem';

export const getCertifiedCourseRegistrations = (state: StoreType) => {
  return Object.values(state.courses.certifiedCourseRegistrations.byMindItemId)
    .sort((a,b) => new Date(b.certifiedAt || '').getTime() - new Date(a.certifiedAt || '').getTime());
};

export const getCertifiedCourseRegistrationsStatus = (state: StoreType) => {
  return state.courses.certifiedCourseRegistrations.status;
};

const getCourseRegistrationByCourseId = (state: StoreType, courseId: string) => 
  Object.values(state.courses.courseRegistrations.byMindItemId)
    .find(courseRegistration => courseRegistration.mindItem?.course.id === courseId);

export const selectCourseRegistrationByCourseId = createSelector([getCourseRegistrationByCourseId], 
  (courseRegistration) => {
    if (!courseRegistration) return;

    return courseRegistration;
  });

export const isCoursesPageLoading = (state: StoreType, store: 'allCourses' | 'progressCourses' | 'successCourses') => {
  const pages = state.courses[store].pages;
  const pageStatus = pages.map(page => page.status);
  return pageStatus.some(status => status === AsyncActionStatus.LOADING);
};

export const getPaginationSelector = 
  (elements: 'allCourses' | 'progressCourses' | 'successCourses') => (store: StoreType) => {
    return store.courses[elements].pagination;
  };

export const getLoadingSelector = 
(elements: 'allCourses' | 'progressCourses' | 'successCourses') => (state: StoreType) => {
  const pages = state.courses[elements].pages;
  if (pages.length === 0) {
    return SearchLoadingStatus.NONE;
  }
  if (pages[0].status === AsyncActionStatus.LOADING) {
    return SearchLoadingStatus.INITIAL;
  }
  if (pages[pages.length - 1].status === AsyncActionStatus.LOADING) {
    return SearchLoadingStatus.PAGINATION;
  }
  return SearchLoadingStatus.LOADED;
};

export const getItemsSelector = 
(elements: 'allCourses' | 'progressCourses' | 'successCourses') => (state: StoreType) => {
  const pages = state.courses[elements].pages;
 
  return pages.reduce<MindItem<'course'>[]>((mindItems, page) => {
    const pageResults = page.data && page.data.map(id => state.courses[elements].byId[id]);
 
    if (!pageResults) {
      return mindItems;
    }

    return mindItems.concat(pageResults);
  }, []);
};
